import type { WorkPostDto } from '../../models/workpost/workPostDto';
import { requests } from '../httpClient';

export const WorkPost = {
    getWorkpostListAsync: () => requests.get(`Workpost`),
    getWorkpostByIdAsync: (workpostId: string) => requests.get(`Workpost/${workpostId}`),
    submitWorkpostAsync: (data: WorkPostDto) => requests.post(`Workpost`, data),
    deleteWorkpostAsync: (workpostId: string) => requests.delete(`Workpost/${workpostId}`)
};
